import React from 'react';

const NotFoundPage = () => (
	<div 
		className="container mb-0 d-flex flex-column flex-grow-1 justify-content-center align-items-center"
	>
		<h1>404</h1>
		<h3> This page doesn&apos;t exist</h3>
	</div>
)
export default NotFoundPage;